import { LayoutGrid } from 'lucide-vue-next'
import type { App } from 'vue'
import { registerComponents } from './components'

export const createDashboard = () => ({
  install: (app: App) => {
    registerComponents(app)

    app.getRouter().addRoute('organization', {
      path: 'dashboard',
      name: 'dashboard',
      meta: {
        head: { titleKey: 'dashboard.title' },
        nav: { icon: LayoutGrid, order: 0 },
        crumbs: [{ labelKey: 'nav.workspace' }, { labelKey: 'dashboard.title' }]
      },
      component: () => import('./pages/DashboardPage.vue')
    })
  }
})
